var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWind(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 52,
    viewBox: "0 0 53 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.77774 17.3333H20.8611C23.8526 17.3333 26.2777 14.9082 26.2777 11.9167C26.2777 8.92512 23.8526 6.5 20.8611 6.5C17.8695 6.5 15.4444 8.92512 15.4444 11.9167V12.6905",
    stroke: "white",
    strokeWidth: 3.25,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.94424 30.3333H40.3609C44.5491 30.3333 47.9442 33.7285 47.9442 37.9167C47.9442 42.1048 44.5491 45.5 40.3609 45.5C36.1728 45.5 32.7776 42.1048 32.7776 37.9167V36.8333",
    stroke: "white",
    strokeWidth: 3.25,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.61124 23.8333H40.3612C44.5494 23.8333 47.9446 20.4381 47.9446 16.25C47.9446 12.0618 44.5494 8.66666 40.3612 8.66666C36.1731 8.66666 32.7779 12.0618 32.7779 16.25V17.3333",
    stroke: "white",
    strokeWidth: 3.25,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWind);
export default __webpack_public_path__ + "static/media/Wind.f0ccf619b004706be6a8b5a7cb6b04c6.svg";
export { ForwardRef as ReactComponent };